import css from 'styled-jsx/css';

export default css`.cirbtn {
  width: 88px;
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 2;
  cursor: pointer; }
  @media only screen and (max-width: 500px) {
    .cirbtn {
      display: none; } }
  .cirbtn img {
    width: 100%; }
`